import { ReactElement, useEffect } from 'react';

import { Stack, Typography } from '@mui/material';
import { Header, Profile } from '../components';
import { useUpdateUserProfileMutation, useUserProfileForm } from '../hooks';
import { FormProvider } from 'react-hook-form';
import { useUserInfo } from '@/features/users';
import { UpdateDataTrigger } from '../components/UpdateDataTrigger';

export const Settings = (): ReactElement => {
  const form = useUserProfileForm();
  const user = useUserInfo();
  const updateUserProfileMutation = useUpdateUserProfileMutation();

  useEffect(() => {
    form.reset(user);
  }, []);

  const handleSubmit = form.handleSubmit((formData) =>
    updateUserProfileMutation.mutate({
      email: formData.email,
      firstName: formData.firstName,
      lastName: formData.lastName,
      twoFactorEnabled: formData.twoFactorEnabled,
    }),
  );

  return (
    <FormProvider {...form}>
      <Stack component="form" onSubmit={handleSubmit}>
        <UpdateDataTrigger />
        <Header />
        <Profile />
      </Stack>
    </FormProvider>
  );
};
